<i18n src="./resources/locales.json"></i18n>
<template>
  <div class="chat-body-container">
    <div class="inset-fade-effect" />
    <v-container class="darken-surface pt-6 body-container" ref="messagesContainer">
      <div class="message" v-for="(message, index) in messages" :key="message.Originator + '-' + index">
        <EcsMessage :message="message" />
      </div>
    </v-container>
  </div>
</template>

<script>
import EcsMessage from '../ecs-message/EcsMessage';

export default {
  name: 'EcsCustomerChatBody',
  components: {
    EcsMessage
  },
  data() {
    return {
      messages: [
        {
          IconType: 'agent',
          Content: this.$t('agentMessage'),
          Originator: 'Jane Doe'
        },
        {
          IconType: 'me',
          Content: this.$t('customerMessage'),
          Originator: 'John Doe'
        }
      ]
    };
  }
};
</script>
<style scoped>
.body-container {
  height: 400px;
}
.chat-body-container {
  position: relative;
}
.inset-fade-effect {
  width: 100%;
  background: linear-gradient(to bottom, #0002 15%, #0000 90%);
  height: 5px;
  position: absolute;
  top: 0;
  z-index: 1;
  transition: all 0.3s ease;
}

[dark] .inset-fade-effect {
  background: linear-gradient(to bottom, #0003 0%, #0000 100%);
}
</style>
